import React from 'react';
//Component Imports
import Routes from './components/utils/Routes';
//Styling
import './App.css';

function App() {
    return (
        <div className='App'>
            <Routes />
        </div>
    );
}

export default App;
